<template>
  <div id="func-3">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
      :customVoltar="true"
      @click="back"
    />
    <GrupoFamiliar
      v-model="beneficiarioSelecionado"
      :style="beneficiarioSelecionado ? 'min-height: 600px' : ''"
      id-funcionalidade="60"
    >
      <div id="conexa"></div>
    </GrupoFamiliar>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import GrupoFamiliar from '@/components/GrupoFamiliar/GrupoFamiliar'

export default {
  name: 'Func60Communicator',
  components: {
    FuncionalidadeHeader,
    GrupoFamiliar
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    }
  },
  watch: {
    beneficiarioSelecionado () {
      this.getMagicLink()
    }
  },
  data () {
    return {
      loaded: false,
      beneficiarioSelecionado: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.loaded = false
    },
    async getMagicLink () {
      if (!this.beneficiarioSelecionado || this.beneficiarioSelecionado === null) {
        return
      }
      const response = await this.apiFuncionalidade.obtemLinkMagico({
        loading: true,
        payload: {
          ...this.beneficiarioSelecionado
        },
        notifyFailure: true,
        handlerErrorIgnore: true
      })
      if (response.status) {
        const url = response.data.linkMagico.web
        window.open(url, '_blank')
      } else {
        this.beneficiarioSelecionado = null
      }
    },
    back () {
      if (this.beneficiarioSelecionado) {
        this.beneficiarioSelecionado = null
      } else {
        window.history.go(-1)
      }
    }
  }
}
</script>
<style scoped>
.cartao {
  height: 265px;
  width: 450px;
  background-size: contain;
  border-radius: 15px;
  position: absolute;;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.cartao-container {
  height: 265px;
  width: 450px;
  border-radius: 15px;
  position: relative;
  box-shadow: 0 3px 30px #0000001A;
}
</style>
